import { Component, OnInit, ViewChild } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';
import { FormControl } from '@angular/forms';
import { startWith, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { PipeTransform, Pipe } from '@angular/core';
import { SharedService } from '../../services/shared.service';
import { PosService } from '../../services/pos.service';
import { InvoiceService } from '../../services/invoice.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PatientService } from '../../services/patient.service';

@Component({
  selector: 'app-invoice-profile',
  templateUrl: './invoice-profile.component.html',
  styleUrls: ['./invoice-profile.component.css']
})
export class InvoiceProfileComponent implements OnInit {

  showErrorMessage: boolean;
  errorMessage: string;
  showLoadingMessage: boolean = false;

  patientDtos: any[] = [];
  lastName: string = "";
  firstName: string = "";  
  inactive: boolean = false;

  constructor(private sharedService: SharedService,
    private router: Router,
    private patientService: PatientService,
    private invoiceService: InvoiceService) { }
  

  ngOnInit() {
    this.sharedService.reloadUserPrivileges();
    this.loadPatientDtos();
  }  

  searchPatient() {
    if (this.lastName == "" && this.firstName == "") {
      this.loadPatientDtos();
    } else {
      this.showLoadingMessage = true;
      this.patientService.getPatients(this.sharedService.pharmacyId, this.sharedService.facilityId, this.sharedService.getUserId(), !this.inactive, this.lastName, this.firstName).subscribe(patients => {
        this.patientDtos = patients;
        this.showLoadingMessage = false;
      },
        err => this.showLoadingMessage = false);
    }
  }

  openProfile(patientId: number) {
    let url = `invoice/profile/${this.sharedService.pharmacyId}/${this.sharedService.facilityId}/${patientId}`;

    this.router.navigate([url]);
  }

  loadPatientDtos() {
    this.showLoadingMessage = true;
    this.patientService.getPatientDtos(this.sharedService.pharmacyId, this.sharedService.facilityId, this.sharedService.getUserId(), !this.inactive).subscribe(patientDtos => {
      this.patientDtos = patientDtos;
      this.showLoadingMessage = false;
    },
      err => this.showLoadingMessage = false);
  }

  onOnlyInactiveChanged() {
    this.loadPatientDtos();
  }

  
  clearErrorMessage() {
    this.showErrorMessage = false;
    this.errorMessage = "";
  }
}
